import React from "react";
import gears from "../../assets/images/gears.png";
import { LoggedInPageTemplate } from "../../core/layout/LoggedInPageTemplate"
import ApiSettingsContainer from "./components/ApiSettingsContainer";
import { strings } from "../../content/strings";

const ApiSettingsPage = () => {

    return (
        <LoggedInPageTemplate
            backgroundImage={gears}
            pageTitle={strings.apiSetting}
            pageDescription=""
            pageCanonical="www.davincilock.com/SerialCodes_Locks/SerialCodeListingByCompany">
            <ApiSettingsContainer />
        </LoggedInPageTemplate >
    );
};

export default ApiSettingsPage;
